import { Button, Container,Navbar } from 'react-bootstrap';
// eslint-disable-next-line no-unused-vars
import storeIcon from 'assets/img/store-icon.svg';
import { useEffect } from 'react';
import { isLogged } from 'services/commons';
import { withLayout } from 'hocs';
// eslint-disable-next-line no-unused-vars
import { BackBar } from 'components';
import { Link, useHistory } from 'react-router-dom';
// eslint-disable-next-line no-unused-vars
import activeCheck from 'assets/img/activeCheck.svg';
import HomeReviews from '../HomeReviews';
import { DATA_PLAN_CARD } from './constant';
import styles from './style.module.scss';
// eslint-disable-next-line no-unused-vars
import { setLoginRedirectSSO } from 'util/navigation';
import { HeaderMobile } from 'components/Mobile';


const Plan = () => {
  const isLoggedIn = isLogged();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const history = useHistory();
  const btnRegresar = () => history.goBack();
  const btnfaqs = () => history.push('/faqs');
  const btnReview = () => history.push('/review');

  return (
    <section>
      <HeaderMobile title="Planes de mesas"/>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
  
      <div className="text-center d-flex-justify-content-center  my-5">
        {/*<img src={storeIcon} alt="Planes" />*/}
        <h3 className="text-center font-weight-bold my-4">
          Planes para tu mesa de regalos
        </h3>
        <h5>En cualquiera de nuestros planes podrás agregar tus regalos y tus invitados podrán comprar desde su celular o cualquier tienda Sears.</h5>
      </div>
      <Container className="p-0 mb-3">
        <section className="d-flex flex-wrap justify-content-around px-4 px-md-0">
          {DATA_PLAN_CARD.map(({ id, title, linkLabel, image, subTitle }) => (
            <article
              className={styles.planCard}
              /*style={{
                background: `
                  no-repeat
                  linear-gradient(
                    1deg,
                    #ffffff 33.14%,
                    rgba(255, 255, 255, 0.5) 100.33%,
                    rgba(255, 255, 255, 0) 117.22%
                  ),
                  url(${image})
                `
              }}*/
            >
              <h5 className="text-primary font-weight-bold">{title}</h5>
                {/* eslint-disable-next-line jsx-a11y/alt-text */}
              <img src={image} className={styles.imgtam}/>
              <h6 className="font-weight-bold">{subTitle}</h6>
              <ul className="text-left" >
                {DATA_PLAN_CARD[id].text.map((card) => (
                    <li className={styles.customlistitem}>
                        <img src={activeCheck} alt="Indicador" /> <p className={styles.textop}>{card}</p>
                    </li>
                ))}
              </ul>
              <a
                className="link-button my-2"
                href={setLoginRedirectSSO('crear-mesa', true, isLoggedIn, true)}
              >
                <Button type="button">{linkLabel}</Button>
              </a>
            </article>
          ))}
        </section>
      </Container>

      {/*<HomeReviews /> */}
    </section>
  );
};

export default Plan;
